import { render, staticRenderFns } from "./DashboardFilters.vue?vue&type=template&id=27a973e2"
import script from "./DashboardFilters.vue?vue&type=script&lang=js"
export * from "./DashboardFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports